import { toast } from "react-toastify";

/**
 * The panel tells an admin their session has ended once per session, not once
 * per request.
 *
 * A session ending refuses every request that was in flight, and each refusal
 * reaches two places: the response interceptor in `helpers/service`, which
 * signs the admin out, and the screen's own catch, which reports the error
 * through `helpers/errorHandler`. Announcing from either of those means one
 * copy of the message per refused request - two of them on any screen that
 * loads two lists, which is what this latch exists to stop.
 */
export const SESSION_EXPIRED_MESSAGE = "Your session has timed out. Please login again.";

let announced = false;

/** Raises the notice for the first refusal, and stays quiet for the rest. */
export function announceSessionExpiry(): void {
  if (announced) return;
  announced = true;

  toast(SESSION_EXPIRED_MESSAGE, {
    theme: "colored",
    type: "error",
  });
}

/** A request that succeeds means a live session again, so the next end is news. */
export function resetSessionExpiryNotice(): void {
  announced = false;
}
